import * as http  from '../http.js';

// 获取直播间详情接口
export const getRoomlive = params => http.get('/v184/room/info',params)
export const getChtaRecord = params => http.get('/v184/chat/record',params)
export const getSearchHot = params => http.get('/v184/search/hot',params)
export const roomBoard = params => http.get('/v300/room/board', params)

export const getSocket = params => http.get('/v19/config',params)
export const getRoomManage = params => http.get('/v184/room/manage',params)
export const withdrawMsg = params => http.patch('/v184/withdraw/message',params)
export const userPopup = params => http.get('/v184/room/popup',params)
export const userMute = params => http.post('/v184/room/mute',params)
export const giftList = params => http.get('/v184/gift/list',params)
export const platformAuth = params => http.get('/v19/platform/auth',params)
// 新增赛程接口
export const getmatchsCategory = params => http.get('/v191/matchs/category',params)
export const evventList = params => http.get('/v191/evvent/list',params)
export const matchsDate = params => http.get('/v191/matchs/date',params)
export const matchsList = params => http.get('/v191/matchs/list',params)
export const reportjb = params => http.post('/v196/report/save',params)
export const moreheadhotdata = params => http.get('/v197/platform',params)